// The whole code is copied from VPC.

import { DataTable } from '@tableau/metrics-engine';
import { IMetricDataPointsSchema } from './IMetricDataList';
import { ContentType } from './ContentType';
import { SearchResultItem } from './SearchResultTypes';

export type ConnectedViewContextType = 'view' | 'customizedView' | 'hiddenView';

export interface IMetricInfo extends IMetricDataInfo {
  luid?: string;
  id: string;
  contentType: ContentType;
  owner?: {
    id: string;
    authId?: string;
    displayName: string;
    username: string;
    domainName?: string;
    readOnly?: boolean;
    userImageUrl?: string;
    isHiddenInternalUser?: boolean;
  };
  updatedAt: Date;
  createdAt: Date;
  suspended: boolean;
  favorite: boolean;
  description: string;
  tags: string[];
  usageInfo?: {
    hitsTotal: number;
    hitsLastOneMonthTotal: number;
    hitsLastThreeMonthsTotal: number;
    hitsLastTwelveMonthsTotal: number;
    favoritesTotal: number;
  };
  connectedView: IConnectedViewInfo;
  location?: {
    type: string;
    id: string;
    name?: string;
  };
}

export type IMetricInfoWithoutData = Omit<IMetricInfo, keyof IMetricDataInfo>;

export interface IMetricDataInfo {
  dataPoints?: DataTable;
  schema?: IMetricDataPointsSchema;
  dataRefreshedTimestamp?: string;
}

export interface IConnectedViewInfo {
  id: string;
  name?: string;
  count?: number;
  viewId: string;
  luid: string;
  isViewModified: boolean;
  path: string;
  thumbnailUrl: string;
  type: ConnectedViewContextType;
}

export function isMetricInfo(metric: SearchResultItem): boolean {
  return metric.contentType === 'metric';
}
